import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { DesignComponent } from './pages/design/design.component';
import { ConfigurationComponent } from './pages/configuration/configuration.component';
import { ProjectComponent } from './pages/project/project.component';
import { CustomerTokenGuard } from './services/guards/customer-token.guard';
import { ErrorComponent } from './pages/error/error.component';
import { IFrameGuard } from './services/guards/i-frame.guard';


const routes: Routes = [
	{ path: '', component: HomeComponent, canActivate:[IFrameGuard] },
	{ path: 'kitchen', children: [
		{ path: 'design', component: DesignComponent, canActivate:[IFrameGuard] },
		{ path: 'configuration', component: ConfigurationComponent, canActivate:[IFrameGuard] },
	]},
	{ path: 'storage', children: [
		{ path: 'configuration', component: ConfigurationComponent, canActivate:[IFrameGuard] },
	]},
	{ path: 'bathroom', children: [
		{ path: 'configuration', component: ConfigurationComponent, canActivate:[IFrameGuard] },
	]},	
	{ path: 'projects', children: [
		{ path: ':projectUUID', component:ProjectComponent, canActivate:[CustomerTokenGuard, IFrameGuard] }
	]},
	{ path: 'error', component: ErrorComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
